<div *ngIf="sessionStatus == 'UPCOMING'" class="text-center mt-5">
  <h3>This session has not started yet!</h3>
</div>

<div #mainContent class="main-container" *ngIf="sessionStatus !== 'UPCOMING'">
  <div class="row" *ngFor="let message of messages">

    <div class="col-8 message other-message" *ngIf="currentUser !==  message.senderId && message.replyType == false">
      <b>{{  message.senderName }}</b>
      <br>
      <span>{{ message.message }}</span>
      <div class="time text-right">
        <small>{{ message.createdAt | date: 'short' }}</small>
      </div>
    </div>
    <div class="col-8 message other-message" *ngIf="currentUser !==  message.senderId && message.replyType == true">
      <b>{{  message.senderName }}</b>
      <div class="message included-reply">
        <b>{{ message.replyTypeUserName }}</b>
        <p>{{ message.replyTypeMessage }}}</p>
      </div>
      <span>{{ message.message }}</span>
      <div class="time text-right">
        <small>{{ message.createdAt | date: 'short' }}</small>
      </div>
    </div>

    <div class="col-8 ml-auto message my-message" *ngIf="currentUser === message.senderId && message.replyType == false">
      <!-- <b>{{ message.senderName }}</b>
      <br> -->
      <span>{{ message.message }}</span>
      <div class="time text-right">
        <small>{{ message.createdAt | date: 'short' }}</small>
      </div>
    </div>
    <div class="col-8 ml-auto message my-message" *ngIf="currentUser === message.senderId && message.replyType == true">
      <!-- <b>{{ message.senderName }}</b> -->
      <div class="message included-reply">
        <b>{{ message.replyTypeUserName }}</b>
        <p>{{ message.replyTypeMessage }}}</p>
      </div>
      <span>{{ message.message }}</span>
      <div class="time text-right">
        <small>{{ message.createdAt | date: 'short' }}</small>
      </div>
    </div>

  </div>
</div>
<div class="input-group send-message-box my-2" *ngIf="sessionStatus == 'LIVE'">
  <div class="input-group-prepend">
    <button class="btn btn-secondary" type="button">
      <i class="fa fa-paperclip" aria-hidden="true"></i>
    </button>
  </div>
  <textarea class="form-control" maxRows="2" [(ngModel)]="newMsg"></textarea>
  <div class="input-group-append">
    <button class="btn btn-success" type="button" [disabled]="newMsg === ''" (click)="sendMessage()">
      <i class="fa fa-paper-plane" aria-hidden="true"></i> Send
    </button>
  </div>
</div>
